import { FactorySelector } from '@/features/factory/components/FactorySelector'
import styles from './FactoryPage.module.scss'

/**
 * Factory root — the "choose a source" menu. Individual factory forms
 * live on their own sub-route (e.g. /factory/viral-shorts). This page
 * only hosts the selector.
 */
export function FactoryPage() {
  return (
    <div className={styles.page}>
      <FactorySelector />
    </div>
  )
}
